import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { ProcedureTypeFieldsRevisionSettingsDetailViewTopBar } from "./TopBar"

export const procedureTypeFieldsRevisionSettingsDetailViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: ProcedureTypeFieldsRevisionSettingsDetailViewTopBar,
}
